<template>
    <wrapper-features-templates-one-column
	noWhiteBox
    thirdLevelMenu
	:customBreadcrumbs="customRouteLink ? breadcrumsGenerator(getMenu, customRouteLink) : null"
	@backOrCloseClicked="$emit('backOrCloseClicked')">
		<div class="buttons-cards-wrapper">
			<button-card
			v-for="menuEntry in thirdLevelMenu"
			:key="`third-level-menu-${menuEntry.id}`"
			:icon="menuEntry.icon"
			:label="menuEntry.name"
			:description="menuEntry.description"
			@clicked="handleClick(menuEntry)"/>
		</div>
	</wrapper-features-templates-one-column>
</template>

<script setup>
import WrapperFeaturesTemplatesOneColumn from '@/components/wrappers/featuresTemplates/OneColumn'
import ButtonCard from '@/components/generic/buttons/Card'
/* Vue & Helpers */
import { navigateByPath, navigateByName } from '@/router/helpers/navigation'
import { routeList } from '@/router/helpers/routes'
import { thirdLevelMenuParser, breadcrumsGenerator } from '@/assets/scripts/parsers/menu'
import { useRoute } from 'vue-router'
import { computed } from 'vue'
/* Store */
import { mapGetters } from '@/store/helpers/mappers'
import { moduleMapper } from '@/store/helpers/modules.map'

/* Emmitters */
const emit = defineEmits(['backOrCloseClicked'])

/* Props received:
@customRouteLink {string} - for mobile we will want to use a custom routeLink to get thirdLevelMenu
*/
const props = defineProps({
	customRouteLink: String
})

const { getMenu } = mapGetters(moduleMapper.MENU)

const currentRoute = useRoute()
const thirdLevelMenu = computed(() => {
	return thirdLevelMenuParser(props.customRouteLink ?? currentRoute.path, getMenu.value)
})

const handleClick = item => {
	if (item.additionalData && item.additionalData.type && item.additionalData.type === 'PAYMENT_OPERATOR') {
		navigateByName({ name: routeList.PAYMENTS_SERVICES_NAME, params: { searchedPaymentData: item.additionalData.paymentOperator } })
	} else {
		if (item.firstTabLink) navigateByPath(item.firstTabLink)
		else navigateByPath(item.link)
	}
}
</script>

<style lang="scss" scoped>
.feature-content-container {
	.one-column-wrapper {
		.buttons-cards-wrapper {
			height: auto;
			margin-top: 16px;

			display: flex;

			flex-direction: row;
			flex-wrap: wrap;
			align-content: flex-start;
			gap: 8px;

			.button-card {
				width: 100%;
			}
		}
	}

	&:not(.mobile) {
		.one-column-wrapper {
			padding: 0;
			background-color: transparent;

			.buttons-cards-wrapper {
				gap: 16px;

				.button-card {
					width: calc(50% - 8px);
				}
			}
		}
	}
}
</style>
